export default __webpack_public_path__ + "static/earth_atmos_2048-5ce4718a2b9554bc405735e62b31315c.jpg";